import { C, fonts } from "../theme.js";
import { SectionLabel } from "./primitives.jsx";
import { CERTS } from "../content.js";

export const Certifications = ({ accent }) => (
  <section style={{ background: C.bg, padding: "0 40px 120px" }}>
    <div style={{ maxWidth: 1280, margin: "0 auto" }}>
      <div style={{ textAlign: "center", marginBottom: 36 }}>
        <SectionLabel accent={accent}>// RECOGNITION</SectionLabel>
      </div>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
          gap: 16,
        }}
      >
        {CERTS.map((c, i) => (
          <div
            key={i}
            style={{
              border: `1px solid ${C.border}`,
              padding: "22px 20px",
              borderRadius: 8,
              display: "flex",
              alignItems: "center",
              gap: 14,
              background: C.card,
            }}
          >
            <div
              style={{
                width: 42,
                height: 42,
                borderRadius: 999,
                border: `1.5px solid ${accent}`,
                display: "grid",
                placeItems: "center",
                fontFamily: fonts.serif,
                fontSize: 18,
                fontWeight: 600,
                color: accent,
                flexShrink: 0,
              }}
            >
              ✓
            </div>
            <div>
              <div
                style={{
                  fontFamily: fonts.sans,
                  fontSize: 14,
                  color: C.fg,
                  fontWeight: 600,
                  lineHeight: 1.2,
                }}
              >
                {c.t}
              </div>
              <div
                style={{
                  fontFamily: fonts.mono,
                  fontSize: 11,
                  color: C.body,
                  marginTop: 4,
                  letterSpacing: "0.04em",
                }}
              >
                {c.s}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
